import { lazy } from 'react'

const Session = lazy(() => import('./session'))

export default {
    Session,
}
